var map = {
	"./BTCMMXN.svg": 86,
	"./ETHMMXN.svg": 87,
	"./USDTMMXN.svg": 88,
	"./XRPMMXN.svg": 89,
	"./bank.svg": 90,
	"./compilant.svg": 91,
	"./dapp.svg": 32,
	"./fiat.svg": 92,
	"./financial.svg": 33,
	"./lowest.svg": 93,
	"./medium.svg": 34,
	"./payments.svg": 35,
	"./remittances.svg": 36,
	"./secure.svg": 94,
	"./store.svg": 37
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 85;